// extracted by mini-css-extract-plugin
module.exports = {"container":"CompareRivals_container__9FwHP","grid":"CompareRivals_grid__5_fqU","shimmer":"CompareRivals_shimmer__OvZqL"};